module.exports = {"private":true,"main":"./TextInput.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/fields/TextInput/package.json
// module id = 839
// module chunks = 0 1